import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'react-final-form'

import SplitButton from '~/components/Buttons/SplitButton'
import { SaveButton } from '~/components/Buttons'

import { SAVE_COMPLETE, SAVE_DRAFT } from '../../constants'

function AdjustmentUpdateButton ({ onSubmit, isLoading }) {
  const submitTypeField = useField('submitType')
  const submitTypeFieldChange = submitTypeField.input.onChange

  const onClickSaveDraft = useCallback(() => {
    submitTypeFieldChange(SAVE_DRAFT)
    return onSubmit()
  }, [onSubmit, submitTypeFieldChange])

  const onClickSaveComplete = useCallback(() => {
    submitTypeFieldChange(SAVE_COMPLETE)
    return onSubmit()
  }, [onSubmit, submitTypeFieldChange])

  const splitButtonOptions = [
    {
      label: 'Save draft',
      button: (
        <SaveButton
          type="button"
          onClick={onClickSaveDraft}
          disabled={isLoading}
          children="Save draft"
        />
      ),
      'data-cy': 'saveDraftMenu',
      onMenuClick: onClickSaveDraft
    },
    {
      label: 'Save & complete',
      button: (
        <SaveButton
          type="button"
          onClick={onClickSaveComplete}
          disabled={isLoading}
          children="Save & complete"
          data-cy="save-complete"
        />
      ),
      'data-cy': 'saveCompleteMenu',
      onMenuClick: onClickSaveComplete
    }
  ]

  return (
    <SplitButton
      name="adjustmentUpdate"
      options={splitButtonOptions}
    />
  )
}

AdjustmentUpdateButton.propTypes = {
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func
}

export default AdjustmentUpdateButton
